/* eslint-disable */
import * as THREE from 'three'
import * as React from 'react'
import { Suspense, useEffect } from 'react'
import { Canvas, useLoader, useThree } from '@react-three/fiber'
import { KeyboardControls } from '@react-three/drei'
import { Physics, RigidBody } from '@react-three/rapier'
import Ecctrl from 'ecctrl'
import { Capsule } from '@react-three/drei'
// ts compiler doesn't like like the file generated by gltfjsx, fix later
// @ts-ignore
import Dust2 from './Dust2'

function SkyBackground(): null {
  const texture = useLoader(THREE.TextureLoader, '/skybox.png')
  const { scene } = useThree()
  useEffect(() => {
    texture.mapping = THREE.EquirectangularReflectionMapping
    texture.colorSpace = THREE.SRGBColorSpace
    scene.background = texture
  }, [texture, scene])
  return null
}

export default function App() {

  const keyboardMap = [
    { name: 'forward', keys: ['ArrowUp', 'KeyW'] },
    { name: 'backward', keys: ['ArrowDown', 'KeyS'] },
    { name: 'leftward', keys: ['ArrowLeft', 'KeyA'] },
    { name: 'rightward', keys: ['ArrowRight', 'KeyD'] },
    { name: 'jump', keys: ['Space'] },
    { name: 'run', keys: ['Shift'] },
  ]

  return (
    <Canvas
            onPointerDown={(e) => {
              if (e.pointerType === "mouse" && e.target instanceof HTMLElement) {
                e.target.requestPointerLock();
              }
            }}>
      <SkyBackground />
      <ambientLight intensity={2} />
      <Suspense>
        <Physics>
          <KeyboardControls map={keyboardMap}>
            <Ecctrl jumpVel={1.5} // jump velocity
                    position={[-10, 5, 12]} // character position i think 
                    camCollision={false} // disable camera collision detect (useless in FP mode)
                    camInitDis={-0.01} // camera intial position
                    camInitDir={{x: 0, y: Math.PI/2}}
                    camMinDis={-0.01} // camera zoom in closest position
                    camFollowMult={1000} // give a big number here, so the camera follows the target (character) instantly
                    camLerpMult={1000} // give a big number here, so the camera lerp to the followCam position instantly
                    turnVelMultiplier={3} // Turning speed same as moving speed
                    turnSpeed={1000} // give it big turning speed to prevent turning wait time
                    mode="CameraBasedMovement"
                    capsuleRadius={0.3}
                    >
              <Capsule  />
            </Ecctrl>
          </KeyboardControls>
          <RigidBody colliders="trimesh" type="fixed">
            <Dust2 />
          </RigidBody>
        </Physics>
      </Suspense>
    </Canvas>
  )
}
